import { getStoreBuilder } from 'vuex-typex'
import { ConvoState } from './state'
import { RootState } from '..'
import { IConvo, Convo, ConvoForm, ConvoMeta } from '../../model/convo'
import addConvo from './actions/add-convo'
import fetchConvos from './actions/fetch-convos'
import likeConvo from './actions/like-convo'
import unlikeConvo from './actions/unlike-convo'
import editConvo from './actions/edit-convo'
import copyConvo from './actions/copy-convo'
import addSearchTag from './actions/add-search-tag'
import removeSearchTag from './actions/remove-search-tag'
import toggleCreatedByUser from './actions/created-by-user'
import toggleCreatedByFollowing from './actions/created-by-following'
import toggleCreatedByMe from './actions/created-by-me'
import toggleLikedByUser from './actions/liked-by-user'
import toggleLikedByFollowing from './actions/liked-by-following'
import toggleLikedByMe from './actions/liked-by-me'
import toggleFollowedByMe from './actions/followed-by-me'
import { IStatement } from '../../model/statement'
import { IComment } from '../../model/comment'
import { IUser } from '../../model/user'
import { SearchQuery, ConvoSearchForm } from '../../model/search/search-query'
import { IReference, Reference } from '../../model/reference'
import setConvoQuery from './actions/set-convo-query'
import followConvo from './actions/follow-convo'
import unfollowConvo from './actions/unfollow-convo'
import addFormStatement from './actions/add-form-statement'
import removeFormStatement from './actions/remove-form-statement'
import addComment from './actions/add-comment'
import addConvoTag from './actions/add-convo-tag'
import removeConvoTag from './actions/remove-convo-tag'
import addConvoReference from './actions/add-convo-reference'
import removeConvoReference from './actions/remove-convo-reference'
import jybeStatement from './actions/jybe-statement'
import unjybeStatement from './actions/unjybe-statement'
import considerStatement from './actions/consider-statement'
import unconsiderStatement from './actions/unconsider-statement'
import ignoreStatement from './actions/ignore-statement'
import unignoreStatement from './actions/unignore-statement'
import fetchAllJybed from './actions/fetch-all-jybed'
import fetchAllJybedForUser from './actions/fetch-all-jybed-user'
import setCommentJybedForUser from './actions/set-comment-jybed-user'
import resetConvoForm from './actions/reset-convo-form'
import initFetchConvos from '@/store/convo/actions/init-fetch-convos'
import addConvoStatement from './actions/add-convo-statement';
import removeConvoStatement from './actions/remove-convo-statement';
import updateConvo from './actions/update-convo';
import editConvoStatements from './actions/edit-convo-statements';
import hideConvoStatements from '@/store/convo/actions/hide-convo-statements';
import editCommentStatements from '@/store/convo/actions/edit-comment-statements';
import addCommentStatement from '@/store/convo/actions/add-comment-statement';
import removeCommentStatement from '@/store/convo/actions/remove-comment-statement';
import addConvoCommentStatement from '@/store/convo/actions/add-convo-comment-statement';

const initialState: ConvoState = {
  convos: [],
  convosStatus: 0,
  convo: new Convo(),
  convoStatus: 0,
  convoForm: new ConvoForm(),
  convoQuery: new SearchQuery(),
  convoSearchForm: new ConvoSearchForm(),
  selectStatements: [],
  isLoading: false
}

const storeBuilder = getStoreBuilder<RootState>()
const moduleBuilder = storeBuilder.module<ConvoState>('convo', initialState)
const stateReader = moduleBuilder.state()

const convoStore = {
  get state () { return stateReader() },

  get isLoading ():boolean { return this.state.isLoading },

  commitSetIsLoading: moduleBuilder.commit((state: ConvoState, payload: { isLoading: boolean }) => {
    state.isLoading = payload.isLoading
  }, 'setIsLoading'),
  commitSetConvos: moduleBuilder.commit((state: ConvoState, payload: { convos: IConvo[] }) => {
    state.convos = payload.convos
  }, 'setConvos'),
  commitAddConvo: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    state.convos.push(payload.convo)
  }, 'addConvo'),
  commitSetConvo: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => state.convo = payload.convo, 'setConvo'),
  commitUpdateConvo: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    state.convo.title = payload.convo.title
    state.convo.body = payload.convo.body
  }, 'updateConvo'),
  commitSetNumLikes: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, numLikes: number }) => {
    console.log('Setting numlikes for convo: %j = %j', payload.convo.id, payload.numLikes)
    if (payload.convo.meta) payload.convo.meta.numLikes = payload.numLikes
  }, 'setNumLikes'),
  commitSetIsLiked: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, isLiked: boolean }) => {
    if (payload.convo.meta) payload.convo.meta.isLiked = payload.isLiked
  }, 'setIsLiked'),
  commitSetIsFollowed: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, isFollowed: boolean }) => {
    if (payload.convo.meta) payload.convo.meta.isFollowed = payload.isFollowed
  }, 'setIsFollowed'),
  commitSetIsAllJybed: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, isAllJybed: boolean }) => {
    if (payload.convo.meta) payload.convo.meta.isAllJybed = payload.isAllJybed
  }, 'setIsAllJybed'),
  commitSetCreator: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, creator: IUser }) => {
    if (payload.convo.meta) payload.convo.meta.creator = payload.creator
  }, 'setCreator'),
  commitSetTags: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, tags: string[] }) => {
    if (payload.convo.meta) payload.convo.meta.tags = payload.tags
  }, 'setTags'),
  commitSetReferences: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, references: IReference[] }) => {
    if (payload.convo.meta) payload.convo.meta.references = payload.references
  }, 'setReferences'),
  commitSetStatements: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, statements: IStatement[] }) => {
    if (payload.convo.meta) payload.convo.meta.statements = payload.statements
  }, 'setStatements'),
  commitSetComments: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo, comments: IComment[] }) => {
    if (payload.convo.meta) payload.convo.meta.comments = payload.comments
  }, 'setComments'),
  commitAddTagToForm: moduleBuilder.commit((state: ConvoState, payload: { }) => {
    if (state.convoForm.tags.indexOf(state.convoForm.tag) < 0) {
      state.convoForm.tags.push(state.convoForm.tag)
    }
    state.convoForm.tag = ''
  }, 'addTagToForm'),
  commitRemoveTagFromForm: moduleBuilder.commit((state: ConvoState, payload: { tag: string }) => {
    state.convoForm.tags.splice(state.convoForm.tags.indexOf(payload.tag), 1)
  }, 'removeTagFromForm'),
  commitAddReferenceToForm: moduleBuilder.commit((state: ConvoState, payload: { }) => {
    let reference: IReference = new Reference()
    reference.url = state.convoForm.referenceUrl
    reference.description = state.convoForm.referenceDesc
    state.convoForm.references.push(reference)
    state.convoForm.referenceUrl = ''
    state.convoForm.referenceDesc = ''
  }, 'addReferenceToForm'),
  commitRemoveReferenceFromForm: moduleBuilder.commit((state: ConvoState, payload: { index: number }) => {
    state.convoForm.references.splice(payload.index, 1)
  }, 'removeReferenceFromForm'),
  commitResetConvoForm: moduleBuilder.commit((state: ConvoState, payload: { }) => {
    state.convoForm = new ConvoForm()
  }, 'resetConvoForm'),
  commitSetQuery: moduleBuilder.commit((state: ConvoState, payload: { query: SearchQuery }) => {
    state.convoQuery = payload.query
  }, 'setConvoQuery'),
  commitResetCommentForm: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    if (payload.convo.meta) payload.convo.meta.newCommentTitle = ''
    if (payload.convo.meta) payload.convo.meta.newCommentBody = ''
  }, 'resetCommentForm'),
  commitResetConvoTag: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    if (payload.convo.meta) payload.convo.meta.newTag = ''
  }, 'resetConvoTag'),
  commitResetConvoReference: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    if (payload.convo.meta) payload.convo.meta.newUrl = ''
    if (payload.convo.meta) payload.convo.meta.newDesc = ''
  }, 'resetConvoReference'),
  commitEditConvo: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    state.convoForm = new ConvoForm()
    state.convoForm.id = payload.convo.id;
    state.convoForm.title = payload.convo.title ? payload.convo.title : "";
    state.convoForm.body = payload.convo.body ? payload.convo.body : "";
    state.convo = payload.convo;
  }, 'editConvo'),
  commitCopyConvo: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    const meta = payload.convo.meta as ConvoMeta;
    const references = meta.references
    const tags = meta.tags
    state.convoForm = new ConvoForm()
    for (let i = 0; i < references.length; i++) {
      state.convoForm.references.push(references[i])
    }
    for (let i = 0; i < tags.length; i++) {
      state.convoForm.tags.push(tags[i])
    }
  }, 'copyConvo'),
  commitEditConvoStatements: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    state.convo = payload.convo;
  }, 'editConvoStatements'),
  commitEditCommentStatements: moduleBuilder.commit((state: ConvoState, payload: { convo: IConvo }) => {
    state.convo = payload.convo;
  }, 'editCommentStatements'),
/* 
  commitSetSearchUser: moduleBuilder.commit((state: ConvoState, payload: { user: IUser }) => {
    state.convoSearchForm.searchUser = payload.user
  }, 'setSearchUser'),
 */
  dispatchSetConvoQuery: moduleBuilder.dispatch(setConvoQuery),
  dispatchAddConvo: moduleBuilder.dispatch(addConvo),
  dispatchUpdateConvo: moduleBuilder.dispatch(updateConvo),
  dispatchAddConvoTag: moduleBuilder.dispatch(addConvoTag),
  dispatchRemoveConvoTag: moduleBuilder.dispatch(removeConvoTag),
  dispatchAddConvoReference: moduleBuilder.dispatch(addConvoReference),
  dispatchRemoveConvoReference: moduleBuilder.dispatch(removeConvoReference),
  dispatchAddConvoStatement: moduleBuilder.dispatch(addConvoStatement),
  dispatchRemoveConvoStatement: moduleBuilder.dispatch(removeConvoStatement),
  dispatchAddConvoCommentStatement: moduleBuilder.dispatch(addConvoCommentStatement),
  dispatchAddCommentStatement: moduleBuilder.dispatch(addCommentStatement),
  dispatchRemoveCommentStatement: moduleBuilder.dispatch(removeCommentStatement),
  dispatchHideConvoStatements: moduleBuilder.dispatch(hideConvoStatements),
  dispatchAddComment: moduleBuilder.dispatch(addComment),
  dispatchAddFormStatement: moduleBuilder.dispatch(addFormStatement),
  dispatchRemoveFormStatement: moduleBuilder.dispatch(removeFormStatement),
  dispatchFetchConvos: moduleBuilder.dispatch(fetchConvos),
  dispatchLikeConvo: moduleBuilder.dispatch(likeConvo),
  dispatchUnlikeConvo: moduleBuilder.dispatch(unlikeConvo),
  dispatchFollowConvo: moduleBuilder.dispatch(followConvo),
  dispatchUnfollowConvo: moduleBuilder.dispatch(unfollowConvo),
  dispatchCopyConvo: moduleBuilder.dispatch(copyConvo),
  dispatchEditConvo: moduleBuilder.dispatch(editConvo),
  dispatchEditConvoStatements: moduleBuilder.dispatch(editConvoStatements),
  dispatchEditCommentStatements: moduleBuilder.dispatch(editCommentStatements),
  dispatchResetConvoForm: moduleBuilder.dispatch(resetConvoForm),
  dispatchAddSearchTag: moduleBuilder.dispatch(addSearchTag),
  dispatchRemoveSearchTag: moduleBuilder.dispatch(removeSearchTag),
  dispatchToggleCreatedByUser: moduleBuilder.dispatch(toggleCreatedByUser),
  dispatchToggleCreatedByFollowing: moduleBuilder.dispatch(toggleCreatedByFollowing),
  dispatchToggleCreatedByMe: moduleBuilder.dispatch(toggleCreatedByMe),
  dispatchToggleLikedByUser: moduleBuilder.dispatch(toggleLikedByUser),
  dispatchToggleLikedByFollowing: moduleBuilder.dispatch(toggleLikedByFollowing),
  dispatchToggleLikedByMe: moduleBuilder.dispatch(toggleLikedByMe),
  dispatchToggleFollowedByMe: moduleBuilder.dispatch(toggleFollowedByMe),
  dispatchFetchAllJybed: moduleBuilder.dispatch(fetchAllJybed),
  dispatchFetchAllJybedForUser: moduleBuilder.dispatch(fetchAllJybedForUser),
  dispatchSetCommentJybedForUser: moduleBuilder.dispatch(setCommentJybedForUser),
  dispatchJybeStatement: moduleBuilder.dispatch(jybeStatement),
  dispatchUnjybeStatement: moduleBuilder.dispatch(unjybeStatement),
  dispatchConsiderStatement: moduleBuilder.dispatch(considerStatement),
  dispatchUnconsiderStatement: moduleBuilder.dispatch(unconsiderStatement),
  dispatchIgnoreStatement: moduleBuilder.dispatch(ignoreStatement),
  dispatchUnignoreStatement: moduleBuilder.dispatch(unignoreStatement),
  dispatchInitFetchConvos: moduleBuilder.dispatch(initFetchConvos),
}

export default convoStore